export function getUrl() {
    let newhref =window.location.href;
    if (newhref.indexOf("?") > -1) {
        let arr = newhref.split("?")[1].split("&");
        let obj = {};
        for (let i = 0; i < arr.length; i++) {
            let a = arr[i].split("=");
            obj[a[0]] = a[1];
        }
        return obj;
    } else {
        return null;
    }
}